"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialPreviewerContext = exports.PreviewerTheme = void 0;
const react_1 = require("react");
exports.PreviewerTheme = {
    colors: {
        primary: {
            main: 'rgb(0, 36, 119)',
            text: 'white',
        },
        secondary: {
            main: 'rgb(255, 164, 0)',
            text: 'white',
        },
        lightPrimary: {
            main: '#83a6df',
            text: 'black',
        },
        white: '#fff',
        darkGray: '#6f737b',
        lightGray: '#b0bec5',
    },
};
exports.initialPreviewerContext = {
    mapfontFamilyToFontName: () => '',
    imageSources: {
        apphiveLogo: {
            uri: '',
        },
        blockApp: {
            uri: '',
        },
        backgroundlist: {
            uri: '',
        },
        emoji: {
            uri: '',
        },
        robot: {
            uri: '',
        },
    },
    lottieSources: {
        apphiveLoading: undefined,
    },
    Render: {
        Text: () => null,
        SafeAreaView: () => null,
        StatusBar: () => null,
        View: () => null,
        TouchableOpacity: () => null,
        Image: () => null,
        ImageBackground: () => null,
        Lottie: () => null,
        AnimatedFlatList: () => null,
        ScrollView: () => null,
        TextInput: () => null,
        KeyboardAvoidingView: () => null,
        AnimatedView: () => null,
        Modal: () => null,
        FlatList: () => null,
        InterstitialAd: () => null,
    },
    theme: exports.PreviewerTheme,
    routing: {
        goBack: () => null,
        push: () => null,
        cleanPreviousAfterReplace: () => null,
        replaceTop: () => null,
        subscribe: () => null,
        boot: () => null,
        getCurrentParams: () => undefined,
        getCurrentPageId: () => undefined,
        dangerouslySetCurrentPageParam: () => null,
        updateTransitionCurrentPage: () => null,
        isContainsPrevious: () => false,
    },
    navigation: {
        push: () => null,
        replace: () => null,
        goBack: () => null,
    },
    dimentions: {
        window: { height: 0, width: 0 },
        screen: { height: 0, width: 0 },
        statusBarHeight: 0,
    },
    Animated: {},
    firebase: {
        auth: () => ({
            currentUser: null,
            signInWithCustomToken: async () => undefined,
            signInWithEmailAndPassword: async () => undefined,
            createUserWithEmailAndPassword: async () => undefined,
            sendPasswordResetEmail: async () => undefined,
            signOut: async () => undefined,
            onAuthStateChanged: (callback) => {
                callback();
                return () => undefined;
            },
        }),
    },
    auth: {
        saveClientAppTokenInPreviewer: async () => undefined,
        removeAppToken: async () => undefined,
        loadMainAuthSession: async () => null,
        loadApplicationSession: async () => undefined,
        rendererGoogleLogin: async () => null,
        rendererFacebookLogin: async () => null,
        rendererEmailLogin: async () => null,
        renderForgotPassword: async () => undefined,
        rendererEmailSignUp: async () => null,
        rendererLogOut: async () => undefined,
    },
    alert: () => undefined,
};
const PreviewerContext = (0, react_1.createContext)(exports.initialPreviewerContext);
exports.default = PreviewerContext;
